import { useEffect } from 'react';

import { setDocumentTitle } from 'utils/meta/setDocumentTitle';

export function useSetDocumentTitle(title: string | undefined) {
  useEffect(() => {
    if (title) setDocumentTitle(title);
  }, [title]);
}
